/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PremiumScheduleAvailableForAllocationResponseDto } from './PremiumScheduleAvailableForAllocationResponseDto';
import {
    PremiumScheduleAvailableForAllocationResponseDtoFromJSON,
    PremiumScheduleAvailableForAllocationResponseDtoFromJSONTyped,
    PremiumScheduleAvailableForAllocationResponseDtoToJSON,
    PremiumScheduleAvailableForAllocationResponseDtoToJSONTyped,
} from './PremiumScheduleAvailableForAllocationResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface PremiumScheduleAvailableForAllocationListResponseDto
 */
export interface PremiumScheduleAvailableForAllocationListResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof PremiumScheduleAvailableForAllocationListResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<PremiumScheduleAvailableForAllocationResponseDto>}
     * @memberof PremiumScheduleAvailableForAllocationListResponseDto
     */
    items: Array<PremiumScheduleAvailableForAllocationResponseDto>;
}

/**
 * Check if a given object implements the PremiumScheduleAvailableForAllocationListResponseDto interface.
 */
export function instanceOfPremiumScheduleAvailableForAllocationListResponseDto(value: object): value is PremiumScheduleAvailableForAllocationListResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function PremiumScheduleAvailableForAllocationListResponseDtoFromJSON(json: any): PremiumScheduleAvailableForAllocationListResponseDto {
    return PremiumScheduleAvailableForAllocationListResponseDtoFromJSONTyped(json, false);
}

export function PremiumScheduleAvailableForAllocationListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumScheduleAvailableForAllocationListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(PremiumScheduleAvailableForAllocationResponseDtoFromJSON)),
    };
}

export function PremiumScheduleAvailableForAllocationListResponseDtoToJSON(json: any): PremiumScheduleAvailableForAllocationListResponseDto {
    return PremiumScheduleAvailableForAllocationListResponseDtoToJSONTyped(json, false);
}

export function PremiumScheduleAvailableForAllocationListResponseDtoToJSONTyped(value?: PremiumScheduleAvailableForAllocationListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(PremiumScheduleAvailableForAllocationResponseDtoToJSON)),
    };
}

